import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { lastValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})

export class EcommerceService {
  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
  ) {
  }

  async getData(data: any) {
    if (data.sectionType === 'productList') {
      const res: any = await lastValueFrom(this.getProductList(data.businessId, data.categoryId, data.subIndustryId));
      return res?.data;
    }
    if (data.sectionType === 'featuredCategory') {
      const res: any = await lastValueFrom(this.getCategoryData(data.businessId, data.subIndustryId));
      return res?.data;
    }
    if (data.sectionType === 'productDescription') {
      const res: any = await lastValueFrom(this.getProductDesc(data.productId, data.subIndustryId));
      return res?.data;
    }
    return null;
  }
  openServiceDialog(componentName: any, height: any, width: any, maxWidth: any, dataModel: any, position: any = { right: '0px', top: '0px' }) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth: maxWidth,
      data: dataModel,
      disableClose: true,
      position: position,
    });
  }

  getCategoryData(businessId: any, subIndustryId: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/inventory/featured?businessId=${businessId || ''}&subId=${localStorage.getItem('subIndustryId') || subIndustryId}`
    )
  }

  getProductList(businessId: any, categoryId: any, subIndustryId: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/product/category/id?businessId=${businessId || ''}&subIndustryId=${subIndustryId}&categoryId=${categoryId}`
    )
  }
  getAllProducts(payload: any) {
    let isJewellery: boolean = localStorage.getItem('isMaterialBasedPricing') === 'true';
    return this.http.put(environment.baseUrl + `ecommerce/product/item/search?isJewellery=${isJewellery}`, payload);
  }
  getProductDesc(productId: any, subIndustryId: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/product/product/id?itemId=${productId}&subId=${subIndustryId}`
    )
  }

  getAllIndustries() {
    return this.http.get(
      environment.baseUrl + 'admin/ecommerce/subIndustries'
    )
  }

  getOrderList(payload: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/order/user/order`, payload
    )
  }

  previewCodOrder(payload: any) {
    return this.http.post(
      environment.baseUrl + `ecommerce/order/admin/order/preview`, payload
    )
  }

  createCodOrder(payload: any) {
    return this.http.post(
      environment.baseUrl + `ecommerce/order/admin/order`, payload
    )
  }

  getOrderDetailsById(id: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/user/try-home?id=${id}`
    )
  }

  getAppointmentList(payload: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/user/try-home/page`, payload
    )
  }

  updateOrderStatus(orderId: any, status: any, cancelReason: string) {
    return this.http.put(
      environment.baseUrl + `ecommerce/order/update/status?orderId=${orderId}&orderStatus=${status}&orderCancelText=${cancelReason}`, null
    )
  }

  updateEcommerceStatus(id: any, status: any) {
    return this.http.patch(
      environment.baseUrl + `ecommerce/user/try-home/${id}/status?status=${status}`,
      {}
    )
  }

  getListCustomers(payload: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/user/filter/customer`, payload
    )
  }

  getListCustomersDiscount(businessId: any, pageNo: any, pageSize: any, searchText: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/user/filter/customer?businessId=${businessId}&searchText=${searchText}&pageNo=${pageNo}&pageSize=${pageSize}`
    )
  }

  getOrderByCustomerId(customerId: any, status: any) {
    if (status) {
      return this.http.put(
        environment.baseUrl + `ecommerce/user/filter/orders?userId=${customerId}&status=${status}`, ''
      )
    } else {
      return this.http.put(
        environment.baseUrl + `ecommerce/user/filter/orders?userId=${customerId}`, ''
      )
    }

  }

  getUserId(customerId: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/customer360/${customerId}/detail`
    )
  }

  updateProductFromCategoryOrCollection(payload: any) {

    let isJewellery = localStorage.getItem('isMaterialBasedPricing') === 'true' ? true : false;
    let data = {
      ...payload,
      isJewelry: isJewellery
    }
    return this.http.put(
      environment.baseUrl + `ecommerce/inventory/item/category/collection`, data
    )
  }

  updateCategoryFromCollection(payload: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/inventory/item/update/category`, payload
    )
  }

  updateTrackingUrl(url: string, userId: string) {
    return this.http.patch(
      environment.baseUrl + `ecommerce/order/order/track?trackingLink=${url}&userOrderId=${userId}`, ''
    )
  }

  saveCustomer(data: any) {
    return this.http.post(
      environment.baseUrl + `ecommerce/user/business-user/create`, data
    )
  }

  getAdundantCartData(businessId: any, pageNo: any, pageSize: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/order/cart/abandoned/${businessId}?pageNo=${pageNo}&pageSize=${pageSize}`
    )
  }

  searchAdundantCart(businessId: any, keyword: any, pageNo: any, pageSize: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/order/search/abandoned/${businessId}/cart?keyword=${keyword}&pageNo=${pageNo}&size=${pageSize}`
    )
  }

  abundantCartFilter(payload: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/order/cart/abandoned/filter`, payload
    )
  }

  // discount api

  createDiscount(data: any) {
    return this.http.post(
      environment.baseBusinessUrl + `discount-coupon`, data
    )
  }

  getTypeList() {
    return this.http.get(
      environment.baseBusinessUrl + `discount-type-master/list`
    )
  }

  getDiscountList(payload: any) {
    return this.http.put(
      environment.baseBusinessUrl + `discount-coupon`, payload
    )
  }

  updateDiscount(couponId, active) {
    return this.http.put(
      environment.baseBusinessUrl + `discount-coupon/${couponId}/toggle/active?active=${active}`, ''
    )
  }

  deleteDiscountCoupon(id: any) {
    return this.http.delete(
      environment.baseBusinessUrl + `discount-coupon/soft-delete?couponId=${id}`
    )
  }

  getDiscountByCouponId(couponId: string) {
    return this.http.get(
      environment.baseBusinessUrl + `discount-coupon/fetch/coupon/details/id?couponId=${couponId}`
    )
  }


  fetchReviewsByItemId(payload: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/user/filter/reviews`, payload
    )
  }

  getReviewCountByProductId(productId: any, startDate: any, endDate: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/user/rating/review/count?productId=${productId}&startDate=${startDate}&endDate=${endDate}`,
    )
  }

  getCommonPhrases(itemId: any,) {
    return this.http.get(
      environment.baseUrl + `ecommerce/user/all?itemId=${itemId}`,
    )
  }

  editreview(reviewId: any, reviewStatus: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/user/review-rating/${reviewId}/update-status?reviewStatus=${reviewStatus}`, ''
    )
  }

  openreviewratingproducts(businessId: any, payLoad: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/user/review-rating/${businessId}/business-product-review`, payLoad
    )
  }

  deletereview(reviewId: any) {
    return this.http.delete(
      environment.baseUrl + `ecommerce/user/review-rating/${reviewId}/soft-delete`
    )

  }

  getbusinessreviewrating(businessId: any, startDate: any, endDate: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/user/rating-reviews/graph/stats?businessId=${businessId}&startDate=${startDate}&endDate=${endDate}`
    )
  }

  getproductreviewrating(itemId: any, startDate: any, endDate: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/user/rating-reviews/graph/stats?itemId=${itemId}&startDate=${startDate}&endDate=${endDate}`
    )
  }

  globalbusinessreview(businessId: string, startDate: any, endDate: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/user/rating/review/count?businessId=${businessId}&startDate=${startDate}&endDate=${endDate}`
    )
  }

  listreviewdproducts(businessId: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/user/rating-review/${businessId}/status-wise/count`
    )
  }

  getEcomDashboardData(payload: any) {
    return this.http.put(
      environment.baseUrl + `reports/report/ecom/dashboard`, payload
    )
  }

  getNewDahboardData(payload: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/dashboard/`, payload
    )
  }

  exportOrders(businessId: any, sDate: any, eDate: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/order/export/orders?businessId=${businessId}&sDate=${sDate}&eDate=${eDate}`,
      businessId,
      { responseType: 'blob' }
    );
  }

  storeCreation(data: any) {
    return this.http.post(
      environment.baseUrl + `ecommerce/store/create`, data
    );
  }

  storeUpdate(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/store/update`, data
    );
  }

  fetchStoreList(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/store/get`, data
    );
  }

  createMaterialType(data: any) {
    return this.http.post(
      environment.baseUrl + `ecommerce/dynamic/material-types`,
      data
    );
  }

  getMaterialTypes(businessId: string, page: number = 0, size: number = 10, search?: string) {
    const params: string[] = [];
    if (businessId) params.push(`businessId=${encodeURIComponent(businessId)}`);
    params.push(`page=${page}`);
    params.push(`size=${size}`);
    if (search) params.push(`search=${encodeURIComponent(search)}`);

    return this.http.get(
      environment.baseUrl + `ecommerce/dynamic/material-types?${params.join('&')}`
    );
  }

  updateMaterialTypeActiveStatus(materialTypeId: string, active: boolean) {
    return this.http.delete(
      environment.baseUrl + `ecommerce/dynamic/material-types/${materialTypeId}?active=${active}`
    );
  }

  storeSearch(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/store/search`, data
    );
  }

  ecommSaveSettings(businessId: string | null, brandPromise: any, videoCall: any, appointmentBooking: any, isDeliveryEnabled: any, isStoresEnabled: any, ExpectedDeliveryDate: any, isMaterialBasedPricing: any) {
    return this.http.post(
      environment.baseUrl + `ecommerce/ecommerce/config/enable?businessId=${businessId}&isBrandPromiseEnabled=${brandPromise}&isVideoCallEnabled=${videoCall}&isAppointmentBookingEnabled=${appointmentBooking}&isDeliveryEnabled=${isDeliveryEnabled}&isStoresEnabled=${isStoresEnabled}&expectedDeliveryDate=${ExpectedDeliveryDate}&materialBasedPricing=${isMaterialBasedPricing}`, {}
    );
  }

  getEcomSettings(businessId: string | null) {
    return this.http.get(
      environment.baseUrl + `ecommerce/ecommerce/config/all?businessId=${businessId}`
    );
  }

  reviewsRatingByProductId(pId: any, pageNo: number, pageSize: number) {
    return this.http.put(
      environment.baseUrl + `ecommerce/user/filter/reviews?productId=${pId}&pageNumber=${pageNo}&pageSize=${pageSize}`, ''
    )
  }
  // Register for newsletter
  registerForNewsletter(email: string, businessId: string, bName: string) {
    const params = [
      `email=${encodeURIComponent(email)}`,
      `businessId=${encodeURIComponent(businessId)}`
    ];
    if (bName) params.push(`bName=${encodeURIComponent(bName)}`);
    return this.http.post(
      environment.baseUrl + `ecommerce/ecommerce/config/registered/newsletter?${params.join('&')}`,
      {}
    );
  }

  // Get all registered emails for newsletter (paginated)
  getRegisteredEmails(businessId: string, email?: string, pageNo: number = 0, pageSize: number = 10) {
    const params = [
      `businessId=${encodeURIComponent(businessId)}`,
      `pageNo=${pageNo}`,
      `pageSize=${pageSize}`
    ];
    if (email) params.push(`email=${encodeURIComponent(email)}`);
    return this.http.get(
      environment.baseUrl + `ecommerce/ecommerce/config/registered/newsletter?${params.join('&')}`
    );
  }

  // Unregister email from newsletter
  unregisterEmail(newsletterId: string) {
    return this.http.delete(
      environment.baseUrl + `ecommerce/ecommerce/config/registered/newsletter/${newsletterId}`
    );
  }

  deleteStore(storeId: string) {
    return this.http.delete(
      environment.baseUrl + `ecommerce/store/delete/${storeId}`
    );
  }

  getStoreStaff(businessId: any, storeId: any) {
    let endPoint: any;
    if (storeId != null) {
      endPoint = `staff/staff/get/store/staff?businessId=${businessId}&storeId=${storeId}`
    }
    else {
      endPoint = `staff/staff/get/store/staff?businessId=${businessId}`
    }
    return this.http.put(
      environment.baseUrl + endPoint, {}
    )
  }

  updateStoreStaff(data: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/update/store/staff`, data
    )
  }

  fetchGstDetails(data: any = {}) {
    return this.http.post(
      `https://api.simpo.ai/payroll/payRoll/verify/gst-no`, data
    )
  }

  getDropdownOptions(BusinessId: any, isJewellery: boolean, isEcommerce: boolean) {
    return this.http.get(
      environment.baseUrl + `ecommerce/menu/dropdown-options/${BusinessId}?isJewellery=${isJewellery}&isEcommerce=${isEcommerce}`
    )
  }

  CreateOrUpdateMenu(data: any) {
    return this.http.post(
      environment.baseUrl + `ecommerce/menu`, data
    )
  }

  getMenuList(data: any) {
    return this.http.post(
      environment.baseUrl + `ecommerce/menu/filter`, data
    )
  }
}
